"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _validator = require("validator");

var _BriefBlock = _interopRequireDefault(require("../../BriefBlock"));

require("../styles/_style-section.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function validateUrl(url) {
  return !url || (0, _validator.isURL)(url);
}

function StyleSection(_ref) {
  var musicStyle = _ref.musicStyle,
      videoStyle = _ref.videoStyle,
      onChangeField = _ref.onChangeField,
      canUpdateVideo = _ref.canUpdateVideo;
  return (/*#__PURE__*/_react.default.createElement(_BriefBlock.default, {
      title: "STYLE"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "style-section__block"
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
      placeholder: canUpdateVideo ? 'Enter music reference' : 'Music reference',
      label: "MUSIC STYLE",
      onChange: onChangeField('musicStyle'),
      defaultValue: musicStyle,
      small: true,
      validate: validateUrl,
      errorMessage: "This doesn't look like a valid website.",
      disabled: !canUpdateVideo
    })), /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
      placeholder: canUpdateVideo ? 'Enter video reference' : 'Video reference',
      label: "VIDEO STYLE",
      onChange: onChangeField('videoStyle'),
      defaultValue: videoStyle,
      small: true,
      validate: validateUrl,
      errorMessage: "This doesn't look like a valid website.",
      disabled: !canUpdateVideo
    }))
  );
}

var _default = (0, _react.memo)(StyleSection);

exports.default = _default;